module.exports = __webpack_public_path__ + "static/media/job-matcher-free-no-bg.480e7d53.svg";